import store from "../../store";
import { TAX_EMPTY_VALIDATION, TAX_ERROR, TAX_HIDE_EMPTY_VALIDATION, TAX_HIDE_ERROR, TAX_REPORT, } from "../../interfaces/Reports/iTaxReport";
import { UNDERSTANDING_ERROR, UNDERSTANDING_HIDE_ERROR, UNDERSTANDING_SECTION, } from "../../interfaces/Reports/iUnderstandingSection";
class TaxReportsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    setErrorUnderStandings(payload) {
        this.dispatch({
            type: UNDERSTANDING_ERROR,
            payload: {
                errorData: payload,
            },
        });
    }
    hideUnderstandingError() {
        this.dispatch({
            type: UNDERSTANDING_HIDE_ERROR,
        });
    }
    setEmptyValidation(emptyValidation) {
        this.dispatch({
            type: TAX_EMPTY_VALIDATION,
            payload: emptyValidation,
        });
    }
    hideEmptyValidation() {
        this.dispatch({
            type: TAX_HIDE_EMPTY_VALIDATION,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: TAX_ERROR,
            payload: {
                errorData: payload,
            },
            errorType: errorType,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: TAX_HIDE_ERROR,
            errorType,
        });
    }
    getTaxReportData(TaxEntityData) {
        this.dispatch({
            type: TAX_REPORT,
            payload: {
                data: TaxEntityData,
            },
        });
    }
    getTaxUnderstandingSectionData(understandSection) {
        this.dispatch({
            type: UNDERSTANDING_SECTION,
            payload: { data: understandSection },
        });
    }
}
export default TaxReportsActions;
